/**
 * Created by ruslan on 04.05.17.
 */
import '@material/icon-toggle/dist/mdc.icon-toggle.min.css';
import '@material/ripple/dist/mdc.ripple.min.css';
export {default as IconToggle} from './IconToggle';


// WEBPACK FOOTER //
// ./src/react-material-components-demo/lib/IconToggle/index.js